import { render, staticRenderFns } from "./textManagement.vue?vue&type=template&id=0d56da15&scoped=true&"
import script from "./textManagement.vue?vue&type=script&lang=js&"
export * from "./textManagement.vue?vue&type=script&lang=js&"
import style0 from "./textManagement.vue?vue&type=style&index=0&id=0d56da15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56da15",
  null
  
)

export default component.exports